module.exports = __webpack_public_path__ + "Maruchibs.webp?830a682090af42722632bf50693b53c3";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/Maruchibs.webp
// module id = 137
// module chunks = 0